import { render, staticRenderFns } from "./formations.vue?vue&type=template&id=022487e9"
import script from "./formations.vue?vue&type=script&lang=js"
export * from "./formations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports